import React from 'react';
// import Loader from "react-loader-spinner";
import Typewriter from 'typewriter-effect';
import './App.css';

function App() {
  // let [isLoaded, setIsLoaded] = useState(false);
  return (
    <React.Fragment>        
      <div className="loading-outer">
        <div className="loading-inner">
          <h1>
            <Typewriter
                options={{
                    cursor: "_",
                    delay: 60,
                    deleteSpeed: 0
                }}
                onInit={(typewriter) => {
                    let lines = [
                        'SMALL IS BEAUTIFUL',
                    ]
                    typewriter.typeString(lines[0])
                        // .pauseFor(2000)
                        // .deleteChars(lines[0].length)
                        // .typeString(lines[1])
                    typewriter.start();
                }}
            />
        </h1>
        </div>
      </div>
  </React.Fragment>      
  );
}

export default App;
